export enum LocationListingType {
  Add,
  Remove = 1
}
